import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import { CircuitPreset } from '@neon-one/neon-circuit';
import type { App } from 'vue';

import { useDarkMode } from '@/shell/composables/useDarkMode';

import '@/styles/circuit.css';
import '@/styles/tokens.css';
import '@/styles/accessibility.css';

export function installTheme(app: App): void {
  app.use(PrimeVue, {
    theme: {
      preset: CircuitPreset,
      options: {
        darkModeSelector: '.my-app-dark',
      },
    },
  });
  // Apply the stored dark-mode preference at bootstrap. Previously only the
  // shells (AuctionsIndexShell / BuilderShell / SupervisorShell) initialized
  // it, so shell-less pages like /donors cold-loaded in light mode no matter
  // what the user had picked.
  useDarkMode();
  // Register v-tooltip so icon-only buttons + cells can declare hover text.
  app.directive('tooltip', Tooltip);
}
